<template>
  <Popup v-model='visible' panelClass='subscribe-panel'>
    <Blocks v-if='source.blocks' :content='JSON.parse(source.blocks)' />
  </Popup>
</template>

<script setup>
  import { ref, computed } from 'vue'
  import { useCookies } from "vue3-cookies";
  import Popup from './Popup.vue'
  import Blocks from './Blocks.vue'

  const { cookies } = useCookies();
  const props = defineProps(['source']);

  const closed = ref(false);
  const dismissed = computed(() => cookies.get('dismissed') === 'true');

  const visible = computed({
    get: () => !closed.value && !dismissed.value,
    set: () => {
      closed.value = true;
      cookies.set('dismissed', 'true');
    }
  });
</script>

<style>
  .subscribe-panel {
    width: 27rem;
    bottom: 3rem;
    right: 2rem;
    padding: 2rem 3rem 3rem;
    background-color: rgba(255, 176, 5, 0.9);
    border-radius: 2rem;
    border: 1px solid var(--border);
    box-shadow: 0 0.25rem 0.5rem var(--blueopacity);
    overflow: hidden;
    text-align: left;
  }
</style>
